import { Component, OnInit, ViewChild } from '@angular/core';
import { MppService } from '@app/mpp/service/mpp.service';
import { PanAppState, PlatformService } from '@panamax/app-state';
import { RecipeDetailService } from '../services/recipe-detail.service';
import { TranslateService } from '@ngx-translate/core';
import { recipeDetailViewModel } from '@app/mpp/model/recipe-detail-view-model';
import { Observable } from 'rxjs';
import { ViewWillEnter } from '@ionic/angular';
import { PageTitle } from '@shared/constants/page-titles.enum';
import { IngredientSearchResult } from '@usf/ngrx-tools';

@Component({
  selector: 'app-ingredients-mobile',
  templateUrl: './ingredients-mobile.page.html',
  styleUrls: ['./ingredients-mobile.page.scss'],
})
export class IngredientsMobilePage implements ViewWillEnter {
  viewModel$: Observable<recipeDetailViewModel>;
  isIngredientSearchModalOpen$ =
    this.recipeDetailService.ingredientSearchModalIsOpen$;
  searchResultsForIngredient$ =
    this.recipeDetailService.searchResultsForIngredient;
  searchResultsForProduct$ = this.recipeDetailService.typeAheadResults;
  searchTimeoutTracker$ = this.recipeDetailService.searchTimeoutTracker$;
  searchNavTimeout;

  constructor(
    public mppService: MppService,
    readonly platformService: PlatformService,
    readonly panAppState: PanAppState,
    readonly translateService: TranslateService,
    public recipeDetailService: RecipeDetailService,
  ) {
    this.viewModel$ = this.recipeDetailService.recipeViewModel$;
  }
  ionViewWillEnter(): void {
    this.setupTitle();
    this.recipeDetailService.updateShowHidePortion(false);
  }

  setupTitle() {
    this.panAppState.setPageTitle(
      this.translateService.instant(PageTitle.mppIngredients),
    );
  }

  clickShowHidePortion = (currentValue: boolean) => {
    this.recipeDetailService.updateShowHidePortion(!currentValue);
  };

  handleYieldChange(value: number, recipeID: string) {
    this.recipeDetailService.updateYield(value, recipeID);
  }

  handleServingChange(value: number, recipeID: string) {
    this.recipeDetailService.updateServing(value, recipeID);
  }

  handleServingPerRecipeChange(value: number, recipeID: string) {
    this.recipeDetailService.updateServingPerRecipe(value, recipeID);
  }

  handleShowServingUOM(event: Event, recipeID: string) {
    this.recipeDetailService.showServingUOMDropdown(event, recipeID);
  }

  handleShowYieldUOM(event: Event, recipeID: string) {
    this.recipeDetailService.showYieldUOMDropdown(event, recipeID);
  }

  openIngredientSearchModal(): void {
    this.recipeDetailService.openIngredientSearchModal();
  }

  closeIngredientSearchModal(): void {
    this.recipeDetailService.closeIngredientSearchModal();
  }

  handleProductViewAll(searchKey: string): void {
    this.closeIngredientSearchModal();
    this.searchNavTimeout = setTimeout(() => {
      this.mppService.gotToProductSearch(searchKey);
    }, 50);
  }

  handleNewIngredientSearchRequest(value: string) {
    this.recipeDetailService.handleNewIngredientSearchRequest(value);
  }

  handleNewIngredientSearchSubmission(value: IngredientSearchResult) {
    this.recipeDetailService.addIngredient(value);
    this.closeIngredientSearchModal();
  }
}
